import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsEN from './assets/i18n/en.json';
import translationsRU from './assets/i18n/ru.json';
import translationsUK from './assets/i18n/uk.json';
import translationsPT from './assets/i18n/pt.json';
import translationsIT from './assets/i18n/it.json';
import translationsFR from './assets/i18n/fr.json';
import translationsPL from './assets/i18n/pl.json';
import translationsDE from './assets/i18n/de.json';

const resources = {
  en: {
    playerNs: translationsEN
  },
  ru: {
    playerNs: translationsRU
  },
  uk: {
    playerNs: translationsUK
  },
  pt:{
    playerNs: translationsPT
  },
  it:{
    playerNs: translationsIT
  },
  fr:{
    playerNs: translationsFR
  },
  pl: {
    playerNs: translationsPL
  },
  de:{
    playerNs: translationsDE
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // default language
    // keySeparator: false, // we do not use keys in form messages.welcome
    // interpolation: {
    //   escapeValue: false // react already safes from xss
    // }
  });
  
  export default i18n;